import i18n from '@/utils/i18n';
import React from 'react';
import { MENU_INFO_ROUTES } from '@/navigators/routes';
import { MenuItem, useMenuInfoContext } from '@/contexts/menu-info-context';
import { MenuItemSearchComponent } from '@/components/menu/search/menu-item-search-component';
import { MenuStackParams } from '@/navigators/types';
import { PageContainer } from '@/components/page-container';
import { StackScreenProps } from '@react-navigation/stack';

type Props = StackScreenProps<MenuStackParams, MENU_INFO_ROUTES.Search>;

export const MenuItemSearchScreen: React.FC<Props> = ({ route }) => {
  const {
    params: { menuItemUUID },
  } = route;
  const { menuItemMap } = useMenuInfoContext();
  const menuItem = menuItemMap.get(menuItemUUID) as MenuItem;

  return (
    <PageContainer
      navigationHeaderProps={{
        centerTitle: true,
        showBackButton: true,
        title: i18n.t('add_ingredient'),
      }}
    >
      <MenuItemSearchComponent menuItem={menuItem} />
    </PageContainer>
  );
};
